import FooterN from '@/app/eflayout/Footer';
import FooterV3 from '@/app/eflayout/FooterV3';
import GloBarTop from '@/app/eflayout/GloBar/GloBarTop';
import GloCart from '@/app/eflayout/GloCart';
import HeaderN from '@/app/eflayout/Header';
import HeaderV2 from '@/app/eflayout/HeaderV2';
import HeaderV3 from '@/app/eflayout/HeaderV3';
import BhStatCommonA from '@/appComps/BhStatCommonA';
import ErrorMonitoringCommon from '@/appComps/ErrorMonitoringCommon';
import RegionPopup from '@/components/Popups/RegionPopup';
import { useGlobal } from '@/utils/useGlobal';
import EcoCreditsWin from '@elem/compCommon/EcoCreditsWin';
import PopupTW from '@elem/compCommon/PopupTW';
import CheckInCountdown from '@elem/ui/ef-check-in-activities/CheckInCountdown';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { FC, useRef } from 'react';
import SignupPopupOut from '../Popups/SignupPopup/SignupPopupOut';
import BackToTop from './BackToTop';
import SetHeaderCssH from './comps/SetHeaderCssH';
import styles from './index.module.scss';
import { newHeaderLocales } from './newHeaderLocales';
import PathTracker from './PathTracker';

//const HeaderN: any = dynamic(() => import('@/app/eflayout/Header'), { ssr: true });
const HeaderO: any = dynamic(() => import('@/components/headerN/header'), { ssr: false });
const FooterO: any = dynamic(() => import('@/components/footerN/footer'), { ssr: false });

type PageLayout = {
    title?: string;
    children?: React.ReactNode;
    className?: string;
    style?: object;
    theme?: string;
    hideHeader?: boolean;
    hideFooter?: boolean;
    isNoFixed?: boolean;
    navChildren?: React.ReactNode;
    hideToTop?: boolean;
    gloBarObjectPage?: any;
};

const PageLayout: FC<PageLayout> = ({
    children,
    navChildren,
    theme = '',
    isNoFixed,
    hideHeader,
    hideFooter,
    hideToTop,
    gloBarObjectPage,
    className = '',
    ...ohterProps
}) => {
    const { textIdA1, headerList = {}, bottomList = {}, gloBarObject, globalTimestamp } = useGlobal();
    const headerVersion = headerList?.version;
    const footerVersion = bottomList?.version;

    // const isShowHeaderV2 = headerVersion === 'V2';
    // const isShowHeaderV3 = headerVersion === 'V3';
    const isShowHeaderV2 = ['V2', 'v3'].includes(headerVersion); // === 'V2';
    const isShowHeaderV3 = false; //headerVersion === 'V3';
    const router = useRouter();
    const { locale = 'us', pathname } = router;
    const showNewHeader = newHeaderLocales.includes(locale);
    const headerRef = useRef<HTMLDivElement | null>(null);
    const gloBarObject2 = gloBarObjectPage || gloBarObject;

    const isShowFooterV2 = ['V1', 'V2', 'V3'].includes(footerVersion); // footerVersion === 'V2';
    const isShowFooterV3 = false; //footerVersion === 'V3';

    let isPreview = false; // 新版导航在二级页面不固定
    if (locale === 'us') {
        switch (true) {
            case pathname.startsWith('/series/'):
            case pathname.startsWith('/preview/'):
                isPreview = true;
                break;
        }
    }

    return (
        <div className={`${styles['pagelayout-bd']} page-layout ${isNoFixed || isPreview ? 'ecoflow-isNoFixed' : ''} ${className}`} {...ohterProps}>
            {!hideHeader && (
                <div className={`ecoflow-frame-header header-${headerVersion}`} ref={headerRef}>
                    <RegionPopup />
                    <GloBarTop gloBarObject={gloBarObject2.__globar_top} headerVersion={headerVersion} />
                    {showNewHeader && (
                        <>
                            {!isShowHeaderV2 && !isShowHeaderV3 && <HeaderN headerList={headerList} />}
                            {isShowHeaderV2 && <HeaderV2 headerList={headerList} />}
                            {isShowHeaderV3 && <HeaderV3 headerList={headerList} locale={locale} />}
                        </>
                    )}
                    {!showNewHeader && <HeaderO />}
                </div>
            )}
            {navChildren}
            <section className="ecoflow-frame-main allContentContainer" id="allContentContainer" role="main">
                {children}
            </section>
            {!hideFooter && !showNewHeader && <FooterO theme={theme} />}
            {!hideFooter && showNewHeader && isShowFooterV2 && <FooterN bottomList={bottomList} theme={theme} />}
            {!hideFooter && isShowFooterV3 && (
                <FooterV3 locale={locale} navItems={bottomList?.detailList || []} theme={['black', 'white'].includes(theme) ? theme : 'black'} />
            )}
            {!['br', 'mx', 'cn', 'sa', 'tw'].includes(locale) && <EcoCreditsWin />}
            {!hideToTop && <BackToTop />}
            <GloCart />
            <CheckInCountdown />
            <BhStatCommonA systemTimestamp={globalTimestamp} textIdA1={textIdA1} />
            <SignupPopupOut />
            <PathTracker />
            <ErrorMonitoringCommon />
            <SetHeaderCssH />
            <PopupTW />
        </div>
    );
};

export default PageLayout;
